interface StatementYearFilterProps {
  statementYears: number[]
  activeStatementYear: number
  onChange: (year: number) => void
}

export function StatementYearFilter({
  statementYears,
  activeStatementYear,
  onChange,
}: StatementYearFilterProps) {
  const handleStatementYearChange = (year: number) => {
    onChange(year)
  }

  return (
    <select
      key={`select-${activeStatementYear}`}
      className="select ta-l w-50%@md"
      value={activeStatementYear}
      onChange={(e) => handleStatementYearChange(Number(e.target.value))}
    >
      {statementYears.map((year) => (
        <option key={year} value={year}>
          Year ending {year}
        </option>
      ))}
    </select>
  )
}
